<template>
  <InlineList
    :items="common"
    v-slot="{ item: groupItem }"
  >
    <InlineList
      v-if="Array.isArray(groupItem)"
      :items="groupItem"
      separator="comma"
      v-slot="{ item }"
    >
      <PreserveLine>
        <BasicLink
          :title="item.title"
          :href="item.href"
          :appearance="appearance"
        />
      </PreserveLine>
    </InlineList>
    <BasicLink
      v-else
      :title="groupItem.title"
      :href="groupItem.href"
      :appearance="appearance"
    />
  </InlineList>
</template>

<script>
  import BasicLink from 'src/components/BasicLink/BasicLink.vue';
  import InlineList from 'src/components/InlineList/InlineList.vue';
  import PreserveLine from 'src/components/text/PreserveLine/PreserveLine.vue';

  export default {
    name: 'VacancySkills',
    components: { BasicLink, PreserveLine, InlineList },
    props: {
      appearance: {
        type: String,
        default: 'dark',
      },
      vacancy: {
        type: Object,
        required: false,
      },
    },
    
    computed: {
      common() {
        const { divisions, salaryQualification, skills } = this.vacancy;
        return [[...divisions, salaryQualification].filter(Boolean), ...skills].filter(Boolean);
      },
    }
  };
</script>